import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Step } from '../../../shared/interfaces/step';

@Component({
    selector: 'app-step-display-html',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step-display-html.component.html',
    styleUrl: './step-display-html.component.scss',
})
export class StepDisplayHtmlComponent {
    @Input() public step: Step | undefined;

    public get content(): string {
        return this.step?.settings?.['content'] as string || '';
    }
}
